export class CheckboxChangeEvent {
  value: string;
  checked: boolean;
  event: any;
}
